import React from "react";
import Navbar from "../components/Navbar";
import Home from "../components/Home";

function Homepage() {
  return (
    <>
      <Navbar />
      <Home />
    </>
  );
}

export default Homepage;
